import * as homeActionType from '../constants/ActionTypes';
import {getSearchParams} from '../utility/auth.helper';

const vuid = getSearchParams().vuid;

const initialState = {
    homeData: {},
    libraryData: [],
    status: '',
    error: null,
    vuid,
    openModal: !!vuid,
    authTab: vuid ? 'registerVoucher' : 'login',
    showHelp: false,
    contactStatus: '',
    openPrivacyPolicyModal: false
};

export const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case homeActionType.SET_HOME_DATA:
            return {...state, homeData: action.payload};
        case homeActionType.SET_HOME_CALL_ERROR:
            return {...state, error: action.payload};
        case homeActionType.SET_VUID:
            // console.log(action.payload);
            return {...state, ...action.payload};
        case homeActionType.TOGGLE_MODAL:
            return {...state, ...action.payload};
        case homeActionType.SHOW_HELP:
            return {...state, ...action.payload};
        case homeActionType.UPDATE_CONTACT_STS:
            return {...state, ...action.payload};
        case homeActionType.SET_AUTHTAB:
            return {...state, ...action.payload};
        case homeActionType.SET_OPEN_PRIVACY_MODAL:
            return {...state, ...action.payload};
        case homeActionType.FETCH_PUBLIC_LIBRARIES_SUCCESS:
            return {...state, libraryData: action.payload};
        case homeActionType.FETCH_PUBLIC_LIBRARIES_ERROR:
            return {...state, error: action.payload};
        default:
            return state;
    }
};
